/**
 * Module dependencies
 */
import qs from 'qs';

/**
 * Request to VD REST API
 *
 * @param {String|Object} params - params object
 * @param {Object} [query] - query object parameter
 * @param {Object} [body] - body object parameter
 * @param {Function} fn - callback function
 * @return {Function} request handler
 */
export default function sendRequest( params, query, body, fn ) {
    
    // `params` can be just the path ( String )
    params = 'string' === typeof params ? { path: params } : params;

    // set `method` request param
    params.method = ( params.method || 'get' );

    // `query` is optional
    if ( 'function' === typeof query ) {
        fn = query;
        query = {};
    }

    // `body` is optional
    if ( 'function' === typeof body ) {
        fn = body;
        body = null;
    }

    // query could be `null`
    query = query || {};

 
    // Stringify query object before to send
    query = qs.stringify( query, { arrayFormat: 'brackets' } );

    // pass `query` and/or `body` to request params
    params.query = query;

    if ( body ) {
        params.body = body;
    }

    // if callback is provided, behave traditionally
    if ( 'function' === typeof fn ) {
        // request method
        return this.request( params, function( err, res, headers ) {
            fn( err, res, headers );
        } );
    }

    // but if not, return a Promise
    return new Promise( ( resolve, reject ) => {
        this.request( params, ( err, res ) => {
            err ? reject( err ) : resolve( res );
        } );
    } );

    
};